var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcWhiteArrowBack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.999 11.071H7.413l5.364-5.364a.999.999 0 10-1.414-1.414l-7.071 7.07a1.001 1.001 0 000 1.416l7.07 7.07a.995.995 0 00.708.293.999.999 0 00.707-1.707l-5.364-5.364h11.586a1 1 0 000-2",
    id: "ic_white_arrow_back_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4 -4)",
    fill: "#fff",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ic_white_arrow_back_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ic_white_arrow_back_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#ic_white_arrow_back_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxwYXRoIGQ9Ik0xOC45OTkgMTEuMDcxSDcuNDEzbDUuMzY0LTUuMzY0YS45OTkuOTk5IDAgMSAwLTEuNDE0LTEuNDE0bC03LjA3MSA3LjA3YTEuMDAxIDEuMDAxIDAgMCAwIDAgMS40MTZsNy4wNyA3LjA3YS45OTUuOTk1IDAgMCAwIC43MDguMjkzLjk5OS45OTkgMCAwIDAgLjcwNy0xLjcwN2wtNS4zNjQtNS4zNjRoMTEuNTg2YTEgMSAwIDAgMCAwLTIiIGlkPSJhIi8+PC9kZWZzPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKC00IC00KSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+PHVzZSB4bGluazpocmVmPSIjYSIvPjwvbWFzaz48ZyBtYXNrPSJ1cmwoI2IpIiBmaWxsPSIjZmZmIj48cGF0aCBkPSJNMCAwaDI0djI0SDB6Ii8+PC9nPjwvZz48L3N2Zz4=";
export { SvgIcWhiteArrowBack as ReactComponent };